export const defaultValidityStatusForm = (): ValidityStatusForm => ({
  name: '',
  color: '#e2e2e2',
});

export const defaultBlurValidityStatusForm = (
  value = false,
): Record<keyof ValidityStatusForm, boolean> => ({
  name: value,
  color: value,
});

export const defaultValidityForm = (): ValidityForm => ({
  // clientName: '',
  productId: '',
  subProductId: '',
  productFullDescription: '',
  productShortDescription: '',
  barcodeNumber: '',
  sectionId: '',
  sectionDescription: '',
  validity: '',
  exitPackaging: '',
  quantity: 0,
  statusName: 'PENDENTE',
  statusColor: '#FF0050',
  observation: '',
  branchCode: '',
  branchName: '',
});

export const defaultBlurValidityForm = (
  value = false,
): Record<keyof ValidityForm, boolean> => ({
  // clientName: value,
  productId: value,
  subProductId: value,
  productFullDescription: value,
  productShortDescription: value,
  barcodeNumber: value,
  sectionId: value,
  sectionDescription: value,
  validity: value,
  exitPackaging: value,
  quantity: value,
  statusName: value,
  statusColor: value,
  observation: value,
  branchCode: value,
  branchName: value,
});
